import { Directive, Input, OnDestroy } from '@angular/core';
import { TemplateRef, ViewContainerRef} from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import {AccountService} from '../core/auth/account.service';

@Directive({
  selector: '[appHasClaim]'
})
export class HasClaimDirective implements OnDestroy  {

  private authorities!: string | string[];

  private readonly destroy$ = new Subject<void>();


  @Input()
  set appHasClaim(value: string | string[])  {
    this.authorities = value;
    this.updateView();
    // Get notified each time authentication state changes.
    this.accountService
        .getAuthenticationState()
        .pipe(takeUntil(this.destroy$))
        .subscribe(() => {
          this.updateView();
        });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private updateView(): void {
    const hasAnyAuthority = this.accountService.hasAnyAuthority(this.authorities);
    this.viewContainer.clear();
    if (hasAnyAuthority) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }

  constructor(  private templateRef: TemplateRef<any>,
                private viewContainer: ViewContainerRef,
                private accountService: AccountService) { }

}
